// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__1Bqtf","content":"LoadingAlert_content__27MWP"};